import { inject, provide } from 'vue'

const WIZARD_KEY = Symbol('fulfillmentWizard')

export const provideWizard = wizard => provide(WIZARD_KEY, wizard)

export const injectWizard = () => inject(WIZARD_KEY)
